import React from 'react';
import { Link } from 'react-router-dom';
import stagingHighlights from 'config/stagingHighlights.json';
import FeatureBadge from 'components/NEW/featureBadge';
import { featureType } from 'utils/featureHighlights';

function StagingHighlights() {
    if (process.env.REACT_APP_DEPLOY_ENV !== 'staging' || stagingHighlights.length === 0) {
        return null;
    }

    return (
        <section
            aria-labelledby="staging-highlights-title"
            className="mx-6 mb-5 rounded-xl border border-amber-300 bg-amber-50 p-5 shadow-sm"
        >
            <div className="mb-4 flex flex-wrap items-center gap-3">
                <h2 id="staging-highlights-title" className="text-lg font-bold text-gray-900">
                    What to test
                </h2>
                <span className="rounded-full bg-amber-200 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-amber-900">
                    Staging
                </span>
            </div>
            <ul className="grid gap-3 md:grid-cols-2">
                {stagingHighlights.map((item) => (
                    <li key={item.id} className="rounded-lg border border-amber-200 bg-white p-4">
                        <h3 className="font-semibold text-gray-900">{item.title}<FeatureBadge type={featureType(item)} /></h3>
                        <ol className="mt-2 list-outside list-decimal space-y-2 pl-5 text-sm text-gray-700">
                            {(item.steps || item.checklist || (item.note ? [item.note] : [])).map((step, index) => (
                                <li key={`${item.id}-${index}`} className="pl-1">{step}</li>
                            ))}
                        </ol>
                        {item.path && (
                            <Link className="mt-3 inline-block text-sm font-medium text-red-700 underline" to={item.path}>
                                Open feature
                            </Link>
                        )}
                    </li>
                ))}
            </ul>
        </section>
    );
}

export default StagingHighlights;
